














































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { EState, IDropDown } from './NewFeedLayout.vue'

@Component
export default class PcButtonArea extends Vue {
  @Prop() actionAreaState!: EState
  @Prop() roleEditTopic!: boolean
  // NWS-1831 掲示板の削除権限（グループ管理者のみ）
  @Prop({ default: false }) roleDeleteTopic!: boolean
  @Prop() isSelectAnyItem!: boolean
  @Prop() private checkAll!: boolean
  @Prop() private sortSelected!: any
  @Prop() private sortOptions!: IDropDown[]
  @Prop() topicLength!: number

  checkAllClone: boolean = this.checkAll
  isCommonTopic = !this.$route.params.groupId
  eState = EState

  @Watch('checkAll')
  watchCheckAll() {
    this.checkAllClone = this.checkAll
  }

  handleMoveToUnclassified(isFromBin: boolean) {
    this.$emit('handleMoveToUnclassified', isFromBin)
  }

  openConfirmDeleteBin(isFromBin: boolean) {
    this.$emit('openConfirmDeleteBin', isFromBin)
  }

  handleSortChange(index: number) {
    this.$emit('handleSortChange', index)
  }

  handleCheckAll() {
    this.$emit('handleCheckAll', this.checkAllClone)
  }

  jumpToCreateTopicPage() {
    this.$emit('jumpToCreateTopicPage')
  }

  pinMultipleTopics() {
    this.$emit('pinMultipleTopics')
  }
}
